var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3909 49.7931L64.6826 32.5014M64.6826 32.5014L47.3909 15.2097M64.6826 32.5014H23.1826M33.5576 49.7931C33.5576 50.8153 33.5576 51.3264 33.5196 51.7691C33.1247 56.3707 29.7357 60.1572 25.2059 61.0578C24.7701 61.1445 24.2617 61.2009 23.2461 61.3138L19.7137 61.7063C14.407 62.2959 11.7535 62.5907 9.64553 61.9162C6.83484 61.0167 4.54018 58.9629 3.33586 56.2687C2.43262 54.2481 2.43262 51.5784 2.43262 46.239V18.7638C2.43262 13.4244 2.43262 10.7547 3.33586 8.73406C4.54018 6.03988 6.83485 3.98606 9.64554 3.08662C11.7536 2.41205 14.4069 2.70687 19.7137 3.29651L23.2461 3.689C24.262 3.80188 24.77 3.85832 25.2059 3.94498C29.7357 4.84563 33.1247 8.63211 33.5196 13.2337C33.5576 13.6764 33.5576 14.1875 33.5576 15.2097",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.9801ac99ee57a8dab2bd655c1eeaae17.svg";
export { ForwardRef as ReactComponent };